import Vue from 'vue'
//拖拽移动
Vue.directive('axisDrag', {
    inserted: function (el) {
        var odiv = el;
        odiv.onmousedown = function (e1) {
            odiv.parentNode.style.zIndex = 999;
            odiv.parentNode.parentNode.parentNode.classList.add('mask-show');
            var e = e1 || window.event; //兼容ie浏览器
            e.stopPropagation()
            e.preventDefault()
            let diffX = e.clientX - odiv.parentNode.offsetLeft; //鼠标点击物体那一刻相对于物体左侧边框的距离=点击时的位置相对于浏览器最左边的距离-物体左边框相对于浏览器最左边的距离
            // let diffY = e.clientY - odiv.parentNode.offsetTop
            document.onmousemove = function (e2) {
                var e = e2 || window.event; //兼容ie浏览器
                e.stopPropagation()
                var left = e.clientX - diffX;
                // var top = e.clientY - diffY;
                // if(top < 0) return false
                if(left < 50) return false
                //控制拖拽物体的范围只能在浏览器视窗内，不允许出现滚动条
                if (left > window.innerWidth - odiv.parentNode.offsetWidth - 72) {
                    left = window.innerWidth - odiv.parentNode.offsetWidth - 72;
                    //left = window.innerWidth;
                }
                // if (top > window.innerHeight - odiv.parentNode.offsetHeight) {
                //     top = window.innerHeight - odiv.parentNode.offsetHeight;
                //     //top = window.innerHeight;
                // }

                //移动时重新得到物体的距离，解决拖动时出现晃动的现象
                odiv.parentNode.style.left = left + 'px';
                odiv.parentNode.style.top = '0';
                // vnode.context.$store.state.dialog[binding.value.type].isMove = true
                // vnode.context.top = top;


            }
            document.onmouseup = function () {
                odiv.parentNode.style.zIndex = 9;
                odiv.parentNode.parentNode.parentNode.classList.remove('mask-show');
                document.onmouseup = "";
                document.onmousemove = "";

            }
        }


    }
})